<template>
  <div class="social-icons-container">
    <a
      v-for="(item, index) in socialData"
      v-bind:key="index"
      v-bind:href="item.link"
      target="_blank"
    >
      <img v-bind:src="item.img" />
    </a>
  </div>
</template>

<script>
const data = [
  {
    link: "https://vk.com/enroller_service",
    img: "icon_vk.png"
  }
];
export default {
  name: "SocialIcons",
  data() {
    return {
      socialData: data
    };
  },
  methods: {
    computedImgLink(data) {
      return data.map(item => {
        const requiredImg = require(`../../assets/img/social/${item.img}`);
        item.img = requiredImg;
        return item;
      });
    }
  },
  computed: {},
  created() {
    this.socialData = [];
    for (let key in data) {
      this.socialData[key] = {};
      this.socialData[key].link = data[key].link;
      this.socialData[key].img = require("../../assets/img/social/" +
        data[key].img);
    }
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.social-icons-container {
  & > a {
    display: inline-block;
    margin-right: 4px;
  }
}
</style>
